import React, { useState } from 'react';
import { Button } from 'reactstrap';
import PropTypes from 'prop-types';
import { map } from 'lodash';
import classnames from 'classnames';
import moment from 'moment';
import ReactImageFallback from 'react-image-fallback';
import Masonry from 'react-masonry-css';
import ReactTooltip from 'react-tooltip';
import {
  FALLBACK_ICON, dateFormats, formatedCurrency, DASHBOARD_EMPTY, getDaysDiff, NUMERIC_VALUE, OFFER_TYPE,
} from '../../../utils';
import { OfferDetail } from '../../modals';

function PrivateOffers(props) {
  const { artistId, offers, loading } = props;
  let hasData = false;
  const [offerDetailModal, setOfferDetailModal] = useState(false);
  const [offerId, setOfferId] = useState(null);

  if (!loading) {
    hasData = !!(offers && offers.length);
  }
  const breakpointColumnsObj = {
    default: 2,
    1100: 2,
    700: 2,
    500: 1,
  };

  const renderPrivateOffer = (list) => map(list, (item) => {
    const {
      clientName, title, participants, basePrice, description, offerMinDate, offerMaxDate, coverImage, basePriceText, clientLogo, _id,
      isContractAccepted, endDeadline, gigType, isClientLogoHide,
    } = item;
    const getDeadlineDays = () => Math.abs(getDaysDiff(new Date(), endDeadline));
    return item && (
      <div
        key={`${clientLogo}`}
        className="flex-card"
      >
        <div className="flex-card-inner">
          <div className="flex-card-cover-image">
            <img
              src={coverImage}
              alt="Cover"
            />
          </div>
          <div
            className="flex-card-cover-body"
            onClick={() => {
              setOfferDetailModal(true);
              setOfferId({ offerId: _id });
            }}
          >
            {
              !isClientLogoHide
                ? (
                  <div className={classnames({
                    'flex-card-image': true,
                  })}
                  >
                    <ReactImageFallback
                      src={clientLogo}
                      fallbackImage={FALLBACK_ICON}
                      alt="cardImage"
                    />
                  </div>
                )
                : (
                  <div className="flex-card-image transparent-background border-0" />
                )
            }
            {gigType && <span className="gigs-badge">{`${OFFER_TYPE[gigType]} gig`}</span>}
            <span className="flex-card-title">{clientName}</span>
            <h3 className="flex-card-subtitle">{title}</h3>
            <p className="flex-card-text">{description}</p>
            <div className="flex-card-offer-text-row">
              {participants?.basePrice > 0 || basePrice > 0 ? (
                <p className="flex-card-offer-text">
                  <em>
                    {!isContractAccepted ? 'Offered' : 'Accepted'}
                    {' '}
                    for
                  </em>
                  <span>
                    $
                    {participants && participants.basePrice !== null ? formatedCurrency(participants.basePrice) : formatedCurrency(basePrice)}
                  </span>
                </p>
              ) : (
                <p className="flex-card-offer-text">
                  <em
                    data-tip={basePriceText}
                    data-place="bottom"
                    data-background-color="#fff"
                    data-text-color="#000"
                  >
                    {basePriceText}
                  </em>
                  <ReactTooltip effect="solid" />
                </p>
                )}
              <p className="flex-card-offer-text">
                <em>Gig timeline</em>
                <span>
                  {moment(offerMinDate).format(dateFormats.DATE_WITH_YEAR)}
                  -
                  {moment(offerMaxDate).format(dateFormats.DATE_WITH_YEAR)}
                </span>
              </p>
              {!isContractAccepted && (
              <p className="flex-card-offer-text">
                {getDeadlineDays() > NUMERIC_VALUE.ZERO
                  && (
                  <>
                    <em>Offer expires in</em>
                    <span>
                      {getDeadlineDays() === 1 ? `${getDeadlineDays()} day` : `${getDeadlineDays()} days`}
                    </span>
                  </>
                  )}
                {
                  getDeadlineDays() === NUMERIC_VALUE.ZERO
                  && <em>Offer expires today</em>
                }
              </p>
              )}
            </div>
            <div className="offer-card-action">
              <Button
                color="acceptRequest"
                element="block"
              >
                Learn More
              </Button>
              <div className="flex-card-error-text expire-text">
                Decline
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  });
  return (
    <>
      {!hasData
        && (
          <div className="empty_box">
            <div className="empty_box_content">
              <img src={DASHBOARD_EMPTY} alt="Empty dashboard" />
              <p>
                Thanks for checking out our available gigs.
                Please check back soon as new opportunities are added frequently.
                We can’t wait to work together!
              </p>
            </div>
          </div>
        )}
      {' '}

      {hasData && (
        <div id="scrollableDiv" className="dashboard-content-card-list ">
          <Masonry
            breakpointCols={breakpointColumnsObj}
            className="dashboard-cards"
            columnClassName="bm-masonry-grid-column"
          >
            {offers && renderPrivateOffer(offers)}
          </Masonry>
        </div>
      )}
      { offerDetailModal && (
        <OfferDetail
          isOpen={offerDetailModal}
          offerIdObj={offerId}
          onClose={() => setOfferDetailModal(false)}
          artistId={artistId}
        />
      )}
    </>
  );
}

PrivateOffers.propTypes = {
  artistId: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
  offers: PropTypes.object.isRequired,
};

export default PrivateOffers;
